import { Component, OnInit, AfterViewInit, Inject } from '@angular/core';
import { MapModel } from 'src/app/model/map.model';
import { MapStore } from 'src/app/store/map.store';
import { MapService } from 'src/app/service/map.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-taracier10',
  templateUrl: './taracier10.component.html',
  styleUrls: ['./taracier10.component.scss']
})
export class Taracier10Component implements OnInit, AfterViewInit {
  dynamicId: string;
  typeOfUnit: string;
  indexOfUnit: string;
  allocatedUnits: MapModel[];
  apartmentsArray: any[];

  constructor(
    private _mapStore: MapStore,
    private _mapService: MapService,
    public dialogRef: MatDialogRef<Taracier10Component>,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    if (data) {
      this.typeOfUnit = data['typeOfUnit'];
      this.indexOfUnit = data['indexOfUnit'];
      this.apartmentsArray = JSON.parse(JSON.stringify(data['apartments']));
      this.apartmentsArray = this.apartmentsArray.sort((a, b) => b.apartmentNumber - a.apartmentNumber);
      this.dynamicId = `${this.typeOfUnit}${this.indexOfUnit}`;
    }
  }

  ngOnInit() { }

  ngAfterViewInit() {
    this._mapStore.set('currentMapStatsUid', this.dynamicId);
    let allocatedUnits = this._mapStore.getByKey('allocatedUnits');
    let reservedUnits = this._mapStore.getByKey('reservedUnits');
    this.disposeMap(allocatedUnits, reservedUnits);
  }

  disposeMap(allocatedUnits: MapModel[], reservedUnits: MapModel[]) {
    this._mapService.disposeMap(allocatedUnits, reservedUnits, this.dynamicId);
  }

  onClick(event: any) {
    this.dialogRef.close();
    this._mapService.onUnitClick(event);
  }

  onRightClick(event) {
    let element = event.target;
    event.preventDefault();
    let uid = element.id === "" ? element.closest("div.apt").id : element.id
    let dealId = element.getAttribute('data-dealid') === null ? element.closest("div.apt").getAttribute('data-dealid') : element.getAttribute('data-dealid');
    let userId = element.getAttribute('data-userId') === null ? element.parentElement.getAttribute('data-userId') : element.getAttribute('data-userId');
    this._mapService.openUserModal(uid, userId, dealId);
  }
}
